import type { CountryCapability } from "../api/catalog";
import { SelectCountrySlot } from "./SelectCountrySlot";

export interface SelectOriginCountrySlotProps {
  countries: CountryCapability[];
  selected?: string | null;
  onSelect: (countryCode: string) => void;
  onClose: () => void;
}

export const SelectOriginCountrySlot: React.FC<SelectOriginCountrySlotProps> = (
  props
) => <SelectCountrySlot titleKey="transfer.selectOrigin" {...props} />;
